import type { StripeSetupFailure } from '#src/app/shared/api/payments';

export function hasGatewayErrorData(
	error: unknown,
): error is StripeSetupFailure & { gatewayErrorData: NonNullable<StripeSetupFailure['gatewayErrorData']> } {
	return typeof error === 'object' && error !== null && 'gatewayErrorData' in error && error.gatewayErrorData !== null;
}
